import EmailConversation from "./EmailConversation";
import EmailItem from "./EmailItem";
import DraftEmailContent from "/lib/html5-software-library/src/ranj/eng/content/DraftEmailContent";
import EmailDraftItem from "./EmailDraftItem";
import EmailBoxType from "./EmailBoxType";
import EmailAddedEvent from "./EmailAddedEvent";
import EmailConversationStatusChangedEvent from "./EmailConversationStatusChangedEvent";

export default class EmailModel {
    constructor(dispatcher, languagePack) {
        this._dispatcher = dispatcher;
        this._languagePack = languagePack;
        
        this._conversationsChronologically = [];
        this._conversationsById = {};
    }

    addEmail(content) {
        const conversationId = content.getSubject();
        let emailItem;
        if (content instanceof DraftEmailContent) {
            emailItem = new EmailDraftItem(content);
        } else {
            emailItem = new EmailItem(content);
        }

        let conversation = this.getConversationById(conversationId);
        if (conversation == null) {
            conversation = new EmailConversation(conversationId, emailItem);
            this.addConversation(conversation);
        } else {
            conversation.addItem(emailItem);
        }

        this._dispatcher.dispatch(EmailAddedEvent.EMAIL_ADDED_TO_CONVERSATION, conversation, emailItem);
    }

    addConversation(conversation) {
        this._conversationsById[conversation.id] = conversation;
        this._conversationsChronologically.add(conversation);
    }

    getConversations() {
        return this._conversationsChronologically;
    }

    getConversationById(id) {
        return this._conversationsById[id];
    }
    
    getConversationForEmailItem(emailItem) {
        const conversationId = emailItem.content.getSubject();
        const conversation = getConversationById(conversationId);

        return conversation;
    }

    markRead(conversation, value = true) {
        conversation.markRead(value);

        this._dispatcher.dispatch(EmailConversationStatusChangedEvent.STATUS_CHANGED, conversation);
    }

    getUnreadCount() {
        const unreadConversations = this._conversationsChronologically.filter(c => c.hasUnreadItems() == true);
        return unreadConversations.length;
    }

    getConversationsForBoxType(emailBoxType) {
        switch (emailBoxType) {
            case EmailBoxType.INBOX:
                return this._conversationsChronologically.filter(c => c.isInbox());
            case EmailBoxType.DRAFTS:
                return this._conversationsChronologically.filter(c => c.requiresReply());
            case EmailBoxType.OUTBOX:
                return this._conversationsChronologically.filter(c => c.isOutbox());
        }
    }

    getUnreadCountForBoxType(emailBoxType) {
        switch (emailBoxType) {
            case EmailBoxType.INBOX:
                return this._conversationsChronologically.filter(c => c.isInbox() && c.hasUnreadItems()).length;
            case EmailBoxType.DRAFTS:
                return this._conversationsChronologically.filter(c => c.requiresReply()).length;
            case EmailBoxType.OUTBOX:
                return 0;
        }
    }
}